/** @format */

import axios from 'axios'
import router from '../router/index'
import $ from 'jquery'
import Vue from 'vue'
const promotionhistory = {
	state: () => ({
		items: [],
		filter: {
			packetIds: [],
			registrationFormId: null,
			searchTerm: null,
			skip: 0,
			take: 20,
			total: 0,
			page: 1,
			checkIn: null,
			isCardPrinted: null,
			voucherSendStatus: null,
			voucherTaskStatus: null,
			voucherType: null,
			activationStatus: null,
			minimumCheckInDate: null,
			groupIDs: null,
			activationCode: null,
			paymentType: null,
			maximumCheckInDate: null,
			paymentStatus: null,
			promotionIDs: null,
			tagIDs: null,
			subEventIDs: null,
			couponCode: null,
			paymentID: null,
			minCardPrintDate: null,
			maxCardPrintDate: null,
			minCheckInDate: null,
			maxCheckInDate: null,
			checkInDateRange: null,
			cardDateRange: null,
			venueMinDate: null,
			venueMaxDate: null,
			venueDateRange: null,
			venueID: null,
			createDateRange: null,
			promotionIDs: [],
			createDateMaxDate: null,
			createDateMinDate: null,
			hasPromotion: true,
		},
		resetFilter: {
			packetIds: [],
			registrationFormId: null,
			searchTerm: null,
			skip: 0,
			take: 20,
			total: 0,
			page: 1,
			checkIn: null,
			isCardPrinted: null,
			voucherSendStatus: null,
			voucherTaskStatus: null,
			voucherType: null,
			activationStatus: null,
			promotionIDs: [],
			minimumCheckInDate: null,
			groupIDs: null,
			activationCode: null,
			paymentType: null,
			maximumCheckInDate: null,
			paymentStatus: null,
			promotionIDs: null,
			tagIDs: null,
			subEventIDs: null,
			couponCode: null,
			paymentID: null,
			minCardPrintDate: null,
			maxCardPrintDate: null,
			minCheckInDate: null,
			maxCheckInDate: null,
			checkInDateRange: null,
			cardDateRange: null,
			venueMinDate: null,
			venueMaxDate: null,
			venueDateRange: null,
			venueID: null,
			createDateRange: null,
			createDateMaxDate: null,
			createDateMinDate: null,
			hasPromotion: true,
		},
	}),
	mutations: {
		promotionResetFilter(state) {
			state.filter = JSON.parse(JSON.stringify(state.resetFilter))
		},
		setPromotionHistorys(state, payload) {
			state.items = payload.items
			state.filter.total = payload.totalCount
		},
	},
	actions: {
		async getPromotionHistory(store) {
			await axios
				.post('participant/list', {
					...store.state.filter,
					skip: (store.state.filter.page - 1) * store.state.filter.take,
				})
				.then((res) => {
					return store.commit('setPromotionHistorys', res.data.data)
				})
		},
	},
	getters: {
		getPromotionHistory: (state) => state.items,
		getPromotionFilter: (state) => state.filter,
	},
}
export default promotionhistory



// WEBPACK FOOTER //
// ./src/store/promotionhistory.js